import { useContext, useState, useRef } from 'react';
import { UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import styles from '../ProductPage.module.scss';
import useApiPrivate from '../../../global/utils/hooks/useApiPrivate';
import { Form, Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Favorite from '../Featured/Favorite';
import Report from '../Featured/Report';
import Share from '../Featured/Share';
import useCalculateIntervalDate from '../../../global/utils/hooks/useCalculateIntervalDate';
import { Button, Spinner, Modal, ModalHeader, ModalBody, FormGroup, Label, Input } from 'reactstrap';
import { useToggle } from '../../../global/utils/hooks/useToggle';
import { useOnChangeHandler } from '../../../global/utils/hooks/useOnChangeHandler';
import useConvertDate from '../../../global/utils/hooks/useConvertDate';
import useAuth from '../../../global/utils/hooks/useAuth';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Toast } from 'primereact/toast';

const ORDER_URL ='api/v1/orders';

export default function ProductSection(props) {
    const { lang } = useContext(UserContext);
    const apiPrivate = useApiPrivate();
    const { id } =useParams();
    const expireDate = useConvertDate({date:props.product.expire_date,withHour:true})
    const { auth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const toast = useRef(null);

    const [isLoading, setIsLoading] = useState(false);

    const [description, setDescription, onChangeHandlerDescription] = useOnChangeHandler('');

    const [modal, setModal, toggleModal] = useToggle(false);

    // const expireDate = (props.product.expire_date).slice(0,10);
    // const [discountInterval] = useCalculateIntervalDate(true, props.product.expire_date);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

    const handleBuyClick = () => {
        if(auth?.token){
            setModal(true);
        } else {
            navigate('/login', {state: {from: location}});
        }
    }

    const orderProduct = async () => {
        setIsLoading(true);

        try {
            const response = await apiPrivate.post(ORDER_URL,{
                product_id: id,
                description
            });
            setIsLoading(false);
            setModal(false);
            showSuccess("Your request has been registered. The seller's contact information will be sent to you via email");
            setTimeout(() => {
                props.handleUpdateProduct();
            }, 3000);
        }
        catch (error) {
            setIsLoading(false);
            showError(error?.response?.data?.message);
        }
        finally {
            setIsLoading(false);
        }
    }

  return (
    <>
        <Toast ref={toast} position="top-center" />

         <Modal isOpen={modal} toggle={toggleModal} size='lg'>
          <ModalHeader toggle={toggleModal}>
            Buy: {props.product.title}
          </ModalHeader>
          <ModalBody>
            <Form>
                <FormGroup>
                    <Label for='description'>
                        Message for the seller
                    </Label>
                    <Input 
                        id='description'
                        name="description"
                        type="textarea"
                        placeholder='Write your message'
                        onChange={onChangeHandlerDescription}
                        value={description}
                    />
                </FormGroup>
            </Form>
            <Button 
                onClick={orderProduct} 
                className={`${styles.buyBtn} px-4 fw-semibold`}
                disabled={isLoading && true}
            >
                {
                    isLoading 
                    ? (
                        <>
                        <Spinner size="sm">
                            Loading...
                        </Spinner>
                        <span>
                            {' '}Loading
                        </span>
                        </>
                    )
                    : 'Buy'
                }
            </Button>
          </ModalBody>
        </Modal>
        <div className={`mb-3`}>
           {/* <Link to={`/product-list/${props.product.category.id}`} className='text-decoration-none text-primary fsSmall'>
                <span>
                    {props.product.category.title}
                </span>
           </Link> */}
            <h1 className={`${styles.title} mb-0`}>
            {props.product.title} 
            </h1>
        </div>
        <div className={`mb-3 ${styles.productDetails}`}>
            {
                props.product?.state?.id &&
                    <div>
                        <i className="bi bi-geo-alt text-primary me-2 big"></i>
                        {
                            props.product?.state?.title && <span>{props.product?.state?.title}</span>
                        }
                        {
                            props.product?.state?.title && props.product?.city?.title && ', '
                        }
                        {
                            props.product?.city?.title && <span>{props.product?.city?.title}</span>
                        }
                    </div>
            }
            {/* <div className={`mb-3`}>
                {
                    props.product.product_status && 
                        <div className="d-inline-block me-2">
                            <i className="bi bi-box-seam text-primary me-2 big"></i>
                            <span>Status: </span>
                            <span>
                                {props.product.product_status}
                            </span>
                        </div>
                }
                <div className="d-inline-block">
                    <span className={`${styles.label}`}>
                        Orginal
                    </span>
                </div>
            </div> */}
            <div>
                <i className="bi bi-calendar-week text-primary me-2 big"></i>
                <span>Expire Date:</span>
                <span>{' '}{expireDate}</span>
            </div>
                {
                    props.product.tags.length > 0 && 
                        <div>
                            <div className="d-inline-block me-2">
                                <i className={`${props.product.tags.length < 2 ? 'bi-tag' : 'bi-tags'} bi  text-primary me-2 big`}></i>
                                <span>{`${props.product.tags.length < 2 ? 'Tag' : 'Tags'}`}:{' '}</span>
                                    {
                                        props.product.tags.map((tag,index) => (
                                            <Link to={`/product-list/?tag=${tag}`} className='text-decoration-none' key={`${tag}`}>
                                                {
                                                    (index < props.product.tags.length - 1) ? `${tag}${', '}` : tag
                                                }
                                            </Link>
                                        ))
                                    }
                            </div>
                        </div>
                }
        </div>
        <div className={`${styles.productPrice} mb-3`}>
            <div className={`${styles.priceBox}`}>
                <div className={`${styles.price}
                     ${props.product.discount > 0 ? `${styles.regularPrice} text-decoration-line-through` : `fw-bold`}`
                     }>
                    <span>$</span>
                    {props.product.price}
                </div>
                {
                    props.product.discount > 0 &&(
                        <div className={`fw-bold ${styles.price} ${styles.discountedPrice}`}>
                            <span>$</span>
                            {props.product.discount_price}
                        </div>)
                }
            </div>
            {
                props.product.discount > 0 &&
                    <div className={`p-2 bg-danger text-white rounded-2 ${styles.discountDesc}`}>
                        <div>
                            <span>
                                {props.product.discount}%
                            </span>
                            {/* <span>{' in '}{discountInterval}</span> */}
                            
                        </div>
                    </div>
            }
        </div>
        <div>
            <Button 
                className={`${styles.buyBtn} px-4 fw-semibold`}
                onClick={handleBuyClick}
                disabled={props.product.status !== 'APPROVE' && true}
            >
                Buy
            </Button>
        </div>
        <div className={`${styles.bottonDivider} py-3`}></div>
        <div className={`${styles.prouductAction} text-center`}>
            <Share title={props.product.title}  />
            <Favorite  productId={id} />
            <GoogleReCaptchaProvider reCaptchaKey="6LepGjAnAAAAAKTvGffqMzdbdak838n5bKC-vy-n">
                <Report productName={props.product.title} />
            </GoogleReCaptchaProvider>
        </div>
        {
            props.product.user_favorite_count != 0 &&
                <div className={`${styles.othersWishlisted} text-center`}>
                    <span className='fw-bold'>
                        {props.product.user_favorite_count}
                    </span>
                    <span>
                        {' '}
                        {
                            props.product.user_favorite_count > 1
                                ? 'others'
                                : 'other'
                        }
                        {' '} wishlisted
                    </span>
                </div>     
        }
    </>
  )
}
